module.exports = __webpack_public_path__ + "img/lpn_default_350px.12405631.png";